import { GlobalFeatureManagementService } from '@rmp/services'

function getBooleanFeatureFlag(flagName) {
  return !!GlobalFeatureManagementService.partnerHubFeatureManager.getBooleanValue(
    flagName
  )
}

export { getBooleanFeatureFlag }
